import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const i18nContent = i18n.createInstance();

if (process.env.REACT_APP_SEO_CONTENT) {
    i18nContent.use(Backend);
}

i18nContent
    .use(initReactI18next)
    .init({
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true,
        },
        backend: process.env.REACT_APP_SEO_CONTENT
            ? { loadPath: process.env.REACT_APP_SEO_CONTENT }
            : undefined,
    });

export default i18nContent;